// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Deposit accounts'"></sub-header>

  <div ng-if="!\$ctrl.productReservations">
    <h2 class="section-header">Please confirm the following:</h2>
    <form name="\$ctrl.form">
      <table class="misc-transaction__table table table--generate-row-ids">
        <tbody>
        <tr>
          <td></td>
          <td>Branches</td>
          <td>
            <multiselect
              items="\$ctrl.branches"
              select-all-option="true"
              label-property="'name'"
              value-property="'id'"
              ng-model="\$ctrl.input.branchIds"
              ng-required="true">
            </multiselect>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Product Type (Checking/Combo)</td>
          <td>
            <select
              required
              ng-model="\$ctrl.selectedProductType"
              ng-options="p as p.productName for p in \$ctrl.allowedAccounts()">
            </select>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>No. of accounts</td>
          <td>
            <input
              ng-model="\$ctrl.input.size"
              type="number"
              required
              min="1"
              max="1000"/>
          </td>
        </tr>
        </tbody>
      </table>
      <div class="buttons">
        <button class="btn btn-warning" ng-click="\$ctrl.goBack()">Back</button>
        <button class="btn btn-warning" ng-click="\$ctrl.initialize()">Clear</button>
        <button class="btn btn-success" ng-click="\$ctrl.submit()" ng-disabled="\$ctrl.form.\$pristine || \$ctrl.form.\$invalid">Reserve</button>
      </div>
    </form>
  </div>

  <div ng-if="\$ctrl.productReservations">
    <h2 class="section-header no-print">Reserved product numbers:</h2>
    <div class="buttons">
      <button class="btn btn-warning" ng-click="\$ctrl.initialize()">Clear</button>
      <button class="btn btn-success" ng-click="\$ctrl.downloadXls()">Download XLS</button>
      <button class="btn btn-success" ng-click="\$ctrl.print()">Print</button>
    </div>
    <report-view report-content="\$ctrl.reportContent"></report-view>
  </div>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/deposit-account/reservation/deposit-account-reservation.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;